import { type Theme } from '@mui/material';
import { MovieStatus, TvStatus } from '@tmdb-graphql-api/schema/types';
import { isFuture, isPast } from 'date-fns';
import { type RibbonSeasonDetailsData } from '../types.ts';

/* eslint-disable no-fallthrough */

export const deriveMovieRibbonColor = (status: MovieStatus, theme: Theme) => {
  let color: string | undefined;

  switch (status) {
    case MovieStatus.InProduction:

    case MovieStatus.PostProduction:

    case MovieStatus.Rumored:

    case MovieStatus.Planned: {
      color = theme.palette.primary.main;

      break;
    }

    default:
    // no default
  }

  return color;
};

export const deriveSeasonRibbonColor = ({ airDate, episodes }: RibbonSeasonDetailsData['season'], theme: Theme) => {
  const lastEpisode = episodes?.length ? episodes.at(-1) : undefined;
  let color: string | undefined;

  switch (true) {
    case airDate && isFuture(new Date(airDate)): {
      color = theme.palette.success.main;

      break;
    }

    case airDate && isPast(new Date(airDate)) && lastEpisode?.airDate && isFuture(new Date(lastEpisode.airDate)): {
      color = theme.palette.primary.main;

      break;
    }

    default:
    // no default
  }

  return color;
};

export const deriveTvRibbonColor = (status: TvStatus, theme: Theme) => {
  let color: string | undefined;

  switch (status) {
    case TvStatus.Canceled:

    case TvStatus.Ended: {
      color = theme.palette.error.main;

      break;
    }

    case TvStatus.ReturningSeries: {
      color = theme.palette.success.main;

      break;
    }

    default:
    // no default
  }

  return color;
};
